module.exports = __webpack_public_path__ + "img/km0.a699125b.png";